export default __webpack_public_path__ + "static/media/DDD-Clinics.098ca879.jpg";